const newContainer = () => import("@/layouts/Default.vue");
const routerParent = () => import("@/layouts/routerParrent.vue");
const questionnaireList = () => import("../views/questionnaireList.vue");
const questionnaireEdit = () => import("../views/edit-questionnaire/index.vue");
const questionnaireAnswerAttemptsList = () =>
  import("../views/answer-attempts/AnswerAttemptsList.vue");

const questionnaireRoutes: any[] = [
  {
    path: "/questionnaire",
    name: "questionnaire-module",
    meta: {
      label: "خانه",
      requiresAuth: true,
      moduleName: "questionnaire",
    },
    component: newContainer,
    children: [
      {
        path: "questionnaire",
        name: "porseshnameh",
        meta: {
          label: "پرسشنامه",
          requiresAuth: true,
          redesigned: true,
          hasAudioNotification: false,
          hasShowParvandehNotification: false,
        },
        redirect: "/questionnaire/questionnaire/list",
        component: routerParent,
        children: [
          {
            path: "list",
            name: "questionnaire-list",
            component: questionnaireList,
            meta: {
              label: "لیست پرسشنامه",
              requiresAuth: true,
              redesigned: true,
            },
          },
          {
            path: ":code/edit",
            name: "questionnaire-edit",
            component: questionnaireEdit,
            meta: {
              label: "ویرایش پرسشنامه",
              requiresAuth: true,
              redesigned: true,
              hasMaxWidth: false,
              hasBottomNavigation: false,
            },
          },
        ],
      },
      {
        path: "execute",
        name: "execute-questionnaire",
        meta: {
          label: "اجرای پرسشنامه",
          requiresAuth: true,
          redesigned: true,
          hasAudioNotification: false,
          hasShowParvandehNotification: false,
        },
        redirect: "/questionnaire/execute",
        component: routerParent,
        children: [
          {
            path: ":code",
            name: "execute-questionnaire-detail",
            component: questionnaireEdit,
            meta: {
              label: "اجرای پرسشنامه",
              requiresAuth: true,
              redesigned: true,
              hasMaxWidth: false,
              hasBottomNavigation: false,
              hasSidebarMenu: false,
              isPreviewMode: true,
              isPreviewHeader: false,
            },
          },
        ],
      },
      {
        path: ":code/azmoon-person-code/:azmoonPersonCode/page/:pageCode/answer-attempts",
        name: "questionnaire-answer-attempts-list",
        component: questionnaireAnswerAttemptsList,
        meta: {
          label: "لیست مرتبه پاسخ‌دهی",
          requiresAuth: true,
          redesigned: true,
        },
      },
    ],
  },
];

export default questionnaireRoutes;
